import {
  DataType,
  DecimalScale,
  Form,
  FormOptions,
  FormSkeleton,
  Section,
  SelectOption,
  useNotify,
  UserPermission
} from '@globaleris/ui.library'
import { SelectList } from '@globaleris/ui.library/build/components/shared/inputs/selectList'
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  makeStyles,
  useTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import {
  Broker,
  Contrato,
  EnumCommodity,
  EnumPrecioUnitario,
  EnumTipoCicloFacturacion,
  EnumTipoPosicion,
  EnumUnidadMedida,
  NewPosicionPrecio,
  NewTramo,
  PosicionPrecio,
  PositionType,
  PriceConceptRequest,
  TradeAditionalsDetails,
  TradeDetailsRequest,
  TradeDetailsResponse,
  TradeMainDetails,
  TradePricingDetails,
  ValidateTradeRulebookModel,
  ValidationType
} from '../../../../api'

import { EnumPriceCalculationType, EnumRedondeo } from '../../../../api/Argentia/enums'
import { EnumTipoMetodoPago } from '../../../../api/oData/enums/enumTipoMetodoPago'
import Page from '../../../../components/page/page'
import PageHeader from '../../../../components/page/pageHeader'
import {
  AccordionSection,
  AddButton,
  PriceExpressionValidator
} from '../../../../components/shared'
import {
  enumEnumToValueNumber,
  enumEnumToValueString,
  enumKeyToValue,
  enumToSelectOptionArray,
  enumToSelectOptionArrayDefaultValues,
  enumValueToKey
} from '../../../../helpers'
import { NonAuthRoutes } from '../../../../model'
import {
  getActiveBalanceZone,
  getActiveCompany,
  getBalanceZonesForCompany,
  getCustomerDomain,
  notifyError,
  storeActiveTrade
} from '../../../../redux'
import { contractsMapperToDropDown } from '../../../floatingConcepts/floatingConcepts.mapper'
import {
  checkCounterpartRulebook,
  checkCreatePastTradeRulebook,
  checkDateTimeLessThanRulebook,
  checkEndDateTractRulebook,
  checkLogElementRulebook,
  checkPositionTypeRulebook,
  checkPresentFutureDatesRulebook,
  checkQuantityRulebook,
  checkStartDateTractRulebook,
  createComplexTrade,
  createPriceForPosition,
  createSimpleTrade,
  deletePosition,
  deleteTradesItems,
  fetchBooks,
  fetchBrokers,
  fetchContractedProducts,
  fetchContracts,
  fetchCounterParts,
  fetchCurrencies,
  fetchDeliveryPoints,
  fetchEnergyMeasureUnits,
  fetchInvoiceCycles,
  fetchTradeTypes,
  fetchUnitPricesByEnergyType,
  getTradeDetails,
  patchTrade,
  validatePositionRulebook,
  validateTradeRulebook,
  fetchCounterPartsExtendedClients,
  fetchDeliveryPointsForExtendedClient,
  fetchContractsForExtendedClient
} from '../../trades.service'

import { useConfirmationDialog, useErrorDetailListDialog, useHttpError } from '../../../../hooks'
import { styles } from '../../edit/tradesEdit.styles'
import {
  balanceZonesMapperToDropDown,
  convertDiffToModel,
  currenciesMapperToDropDown,
  formatPositionsForTable,
  invoiceCycleMapperToDropDown,
  invoiceCyclesMapperToDropDown,
  mapAditionalsToCreateRequest,
  mapFormsToTradeDetails,
  mapStateToCreateComplexTradeRequest,
  mapStateToCreateRequest,
  mapToAPIRequest,
  mapTradeSimpleResponseToForms,
  measureUnitsMapperToDropDown
} from '../../trades.mapper'

import { updatedDiff } from 'deep-object-diff'

import moment from 'moment'
import { EnumNivelCicloFacturacion } from '../../../../api/Pioneer/enums/nivelCicloFacturacion'
import { MeasureUnit } from '../../../../api/Pioneer/model/MeasureUnit'
import { UnitPrice } from '../../../../api/Pioneer/model/UnitPrice'
import ButtonWithPermissions from '../../../../components/buttonWithPermissions/buttonWithPermissions'
import { ErrorDetailList } from '../../../../components/errorDetailList/errorDetailList'
import { parseGroupedFloat } from '../../../../helpers/parseGroupedFloat'
import { hasPermission } from '../../../../helpers/permissionsHelper'
import { missingFieldsForm } from '../../../../helpers/validateFormHelper'
import { ConfirmationDialogs } from '../../../../model/enums/confirmationDialogs'
import { Resources } from '../../../../model/RBAC/constants'
import { PriceDetails } from '../../../pricing/pricing.Model'
import BrokersTable from '../../components/brokersTable/brokersTable'
import { PositionForm } from '../../components/positionForm/positionForm'
import { TradePositionTable } from '../../components/tradePositionTable'
import {
  FetchingDependencies,
  RulebookValidations,
  SelectOptions,
  TradeFormValidations
} from '../../edit/tradesEdit.types'
import {
  checkDates,
  filterMeasureUnits,
  getErrorText,
  getTotalQuantity,
  getUpdatePriceDates,
  getViewButtonDisabledState,
  tradeSimpleSameDates
} from '../../helpers/trades.helper'
import { formatStringNumber } from '../../../../helpers/numberHelper'
import { EnumPriceType } from '../../../../api/oData/enums/enumPriceType'
import { TRADES_TABS } from '../../trades'

export namespace FormMode {
  export const CREATE = 'CREATE'
  export const EDIT = 'EDIT'
}
export type FormModeType = (typeof FormMode)[keyof typeof FormMode]
export interface TradesEditPageProps {
  mode: FormModeType
  tradeData: TradeDetailsResponse | null
  simple: boolean
  currentTab: TRADES_TABS
  goBackTo?: string
}

const initialDependencies: SelectOptions = {
  counterparts: [],
  balanceZones: [],
  deliveryPoints: [],
  tradeTypes: [],
  books: [],
  contractedProducts: [],
  brokers: [],
  currencies: [],
  currenciesOptions: [],
  measureUnitsOptions: [],
  contractOptions: [],
  unitPrices: []
}

const initialFetchingDependencies: FetchingDependencies = {
  balanceZones: false,
  books: false,
  brokers: false,
  contractedProducts: false,
  contractOptions: false,
  counterparts: false,
  currencies: false,
  currenciesOptions: false,
  deliveryPoints: false,
  measureUnitsOptions: false,
  tradeTypes: false,
  unitPrices: false,
  invoiceCycles: false
}

export const initialValidations: TradeFormValidations = {
  isDirty: false,
  counterpart: true,
  initDate: true,
  endDate: true,
  signDate: true,
  quantity: true,
  deliveryPoint: true,
  positionType: true,
  measureUnit: true
}

export const quantityDecimals = 12

//const APIActions = { CREATE: 'CREATE', UPDATE: 'UPDATE', DELETE: 'DELETE' };

export const TradeForm = ({
  mode,
  tradeData,
  simple,
  currentTab,
  goBackTo
}: TradesEditPageProps) => {
  const history = useHistory()

  const [t] = useTranslation(['trades', 'tradesEdit', 'globalerisLibrary', 'rulebook', 'enums'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const { info, error } = useNotify()
  const { showErrorDetailListDialog, errorDetailListDialogProps } = useErrorDetailListDialog()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()
  const { showError } = useHttpError()
  const activeBalanceZone = getActiveBalanceZone()
  const [savedTrade, setSavedTrade] = useState<TradeDetailsResponse | null>(tradeData)
  const [trade, setTrade] = useState<TradeDetailsResponse | null>(tradeData)
  const initialValues: Partial<TradeMainDetails> = {
    currency: 1,
    state: ValidationType.Validated,
    balanceZone: activeBalanceZone?.id
  }
  // If user doesn't have permissions the trade is NOT EDITABLE.
  const userHasPermissions = hasPermission(Resources.Trades, [UserPermission.EDIT])
  //Starts Inputs
  const [formDependencies, setFormDependencies] = useState<SelectOptions>(initialDependencies)
  const [billingCycleOptions, setBillingCycleOptions] = useState<SelectOption[]>([])
  const [contracts, setContracts] = useState<Contrato[]>([])
  const [measureUnits, setMeasureUnits] = useState<MeasureUnit[]>([])
  const [unitPrices, setUnitPrices] = useState<UnitPrice[]>([])
  const [selectedContract, setSelectedContract] = useState<Contrato | undefined>(undefined)

  // Position Form States
  const [positionFormMode, setPositionFormMode] = useState<FormModeType>(FormMode.CREATE)
  const [currentPosition, setCurrentPosition] = useState<NewPosicionPrecio | undefined>(undefined)
  const [positionTableData, setPositionTableData] = useState<NewPosicionPrecio[]>([])
  const [showAddPositionForm, setShowAddPositionForm] = useState(false)
  const [quantitySuffix, setQuantitySuffix] = useState<string>('')
  const [feeSuffix, setFeeSuffix] = useState<string>('')

  // Inputs States
  const [initDateDisabled, setInitDateDisabled] = useState<boolean>(false)
  const [endDateDisabled, setEndDateDisabled] = useState<boolean>(false)
  const [deliveryPointEditable, setDeliveryPointEditable] = useState<boolean>(true)
  const [balanceZoneEditable, setBalanceZoneEditable] = useState<boolean>(true)
  const [typeEditable, setTypeEditable] = useState<boolean>(true)
  const [counterpartEditable, setCounterpartEditable] = useState<boolean>(true)
  const [dailyQuantityEditable, setDailyQuantityEditable] = useState<boolean>(true)
  const [unitMeasuresEditable, setUnitMeasuresEditable] = useState<boolean>(true)
  const [billingLevelDisabled, setBillingLevelDisabled] = useState<boolean>(true)
  const [billingCycleDisabled, setBillingCycleDisabled] = useState<boolean>(true)
  const [contractDisabled, setContractDisabled] = useState<boolean>(false)
  const [startDateMsgError, setStartDateMsgError] = useState<string | undefined>(undefined)
  const [endDateMsgError, setEndDateMsgError] = useState<string | undefined>(undefined)
  const [quantityMsgError, setQuantityMsgError] = useState<string | undefined>(undefined)
  //Ends Inputs

  // Pricing States
  const [priceFields, setPriceFields] = useState<Partial<PriceDetails> | undefined>(undefined)
  const [expressionValidated, setExpressionValidated] = useState<boolean>(true)
  const [priceExpression, setPriceExpression] = useState<string | undefined>(undefined)
  const [priceUnitSelected, setPriceUnitSelected] = useState<EnumPrecioUnitario | undefined>(
    undefined
  )
  const [roundingSelected, setRoundingSelected] = useState<EnumRedondeo | undefined>(undefined)
  const [priceCalculationTypeSelected, setPriceCalculationTypeSelected] =
    useState<EnumPriceCalculationType | null>(null)
  const [priceVersion, setPriceVersion] = useState<number | undefined>(undefined)
  //Ends Pricing

  // General Page States
  const [pendingChanges, setPendingChanges] = useState<boolean>(false)
  const [complexView, setComplexView] = useState<boolean>(!simple)
  const [viewButtonDisabled, setViewButtonDisabled] = useState<boolean>(false)
  const [editMode, setEditMode] = useState<boolean>(userHasPermissions)
  const [mainFormState, setMainFormState] = useState<Partial<TradeMainDetails> | undefined>(
    mode === FormMode.EDIT ? undefined : initialValues
  )
  const [formStateAditionals, setFormStateAditionals] = useState<
    Partial<TradeAditionalsDetails> | undefined
  >(mode === FormMode.EDIT ? undefined : {})
  const [originalTrade, setOriginalTrade] = useState<TradeDetailsRequest>()
  const [tradeResponse, setTradeResponse] = useState<TradeDetailsResponse>()
  const [isFetchingDependencies, setIsFetchingDependencies] = useState<FetchingDependencies>(
    initialFetchingDependencies
  )
  const [isFetching, setIsFetching] = useState<boolean>(mode === FormMode.EDIT)

  // Brokers States
  const [isSimpleCommission, setIsSimpleCommission] = useState(
    !(tradeData && tradeData.brokers && tradeData.brokers.length > 1)
  )
  const [brokersList, setBrokersList] = useState<Broker[]>([])
  const [commisionDisabled, setCommisionDisabled] = useState<boolean>(true)

  //Ends General Page States

  // Form Dirty Validations
  const [validations, setValidations] = useState<TradeFormValidations>(initialValidations)
  const [validInitDate, setValidInitDate] = useState<Date | undefined>(undefined)
  const [validEndDate, setValidEndDate] = useState<Date | undefined>(undefined)
  const [validCounterpart, setValidCounterpart] = useState<number | undefined>(undefined)
  const [validPositionType, setValidPositionType] = useState<number | undefined>(undefined)
  const [validQuantity, setValidQuantity] = useState<number | undefined>(undefined)
  const [validMeasureUnit, setValidMeasureUnit] = useState<number | undefined>(undefined)
  //

  const price: TradePricingDetails = {
    expression: priceExpression,
    priceCalculationType: priceCalculationTypeSelected ?? undefined,
    rounding: roundingSelected,
    currencyAndUnit: priceUnitSelected
  }

  const initialMapper = (updatedTrade: TradeDetailsResponse) => {
    setIsFetching(true)
    const tradeIsSimple = tradeSimpleSameDates(updatedTrade)
    const tradeDetails = mapTradeSimpleResponseToForms(updatedTrade)
    const tradeReq: TradeDetailsRequest = mapFormsToTradeDetails(
      tradeDetails[0],
      tradeDetails[1],
      tradeDetails[2],
      updatedTrade.positions
    )
    setTradeResponse(updatedTrade)
    setOriginalTrade(tradeReq)
    updateFormStates(tradeDetails)
    updatePositionTable(updatedTrade.positions)
    tradeDetails[0].counterpart && setContractDisabled(false)

    tradeIsSimple &&
      setQuantityUnit(
        enumEnumToValueNumber(EnumUnidadMedida, updatedTrade.positions[0].unidadMedida)!
      )
    if (tradeDetails[2].contract) {
      setBillingLevelDisabled(false)
      setBillingCycleDisabled(false)
    }
    if (updatedTrade?.brokers && updatedTrade?.brokers.length > 0) {
      setBrokersList(updatedTrade.brokers)
      setContractedProducts(updatedTrade.brokers)
    }
    resetPriceExpressionForm(updatedTrade)
    setIsFetching(false)
  }

  //#region Handlers

  const fetchTrade = async () => {
    if (trade) {
      setIsFetching(true)
      const response = await getTradeDetails(trade.tradeId)
      if (response.success && response.data) {
        setTrade(response.data)
        setSavedTrade(response.data)
        storeActiveTrade(response.data)
        initialMapper(response.data)
        setIsFetching(false)
      }
    }
  }

  const onDeleteClickHandler = async () => {
    getConfirmation(ConfirmationDialogs.DELETE).then(async () => {
      deleteTradesItems(savedTrade!.tradeId).then(async response => {
        if (response.success) {
          info(
            t('trades:notifications.delete.success', {
              tradeCode: savedTrade?.code
            })
          )
          history.push(NonAuthRoutes.trades)
        } else {
          showErrorDetailListDialog(
            response.error?.message ?? 'Se ha producido un error',
            response.error
              ? [{ code: response.error.code, message: `${response.error.message}` }]
              : [{ code: '412', message: '8001' }],
            t('trades:notifications.delete.error')
          )
        }
      })
      closeConfirmation()
    })
  }

  const onCreateHandler = async () => {
    // To use if handler comes from form options callback.
    // if (formData === undefined) {
    //   // Cancel Button
    //   history.push(NonAuthRoutes.trades);
    //   return false;
    // }

    let formData
    if (complexView) {
      formData = mainFormState ? mapStateToCreateComplexTradeRequest(mainFormState, getActiveCompany()?.id!) : null
    } else {
      formData = mainFormState ? mapStateToCreateRequest(mainFormState, getActiveCompany()?.id!) : null
    }

    const formAditionals = formStateAditionals
      ? mapAditionalsToCreateRequest(formStateAditionals)
      : null
    if (validations.isDirty) {
      notifyError(t('trades:forms.add.notifications.error.validation'))
      return false
    }
    if ((formData && missingFieldsForm(sections, formData)) || formData === null) {
      notifyError(t('trades:forms.add.notifications.error.errorInvalidForm'))
      return false
    } else if (complexView && positionTableData.length < 1) {
      notifyError(t('trades:forms.add.notifications.error.errorPositionRequired'))
      return false
    } else {
      if (formData && formAditionals) {
        const validateTradeRequest: ValidateTradeRulebookModel = {
          tradeId: trade ? trade.tradeId : 0,
          counterpartId: formData.counterpart!,
          initDate: formData.initDate!,
          endDate: formData.endDate!,
          signDate: formData.signDate!
        }

        const checkTradeStrategy = await validateTradeRulebook(
          validateTradeRequest,
          positionTableData && positionTableData.length > 0 ? positionTableData : []
        )
        if (checkTradeStrategy && !checkTradeStrategy.success) {
          showErrorDetailListDialog(
            t('Error de rulebook'),
            checkTradeStrategy.error
              ? [
                  {
                    code: checkTradeStrategy.error.code,
                    message: `${checkTradeStrategy.error.message}`
                  }
                ]
              : [{ code: '412', message: '8001' }],
            t(
              `rulebook:titles.${
                checkTradeStrategy.error?.message ? checkTradeStrategy.error.message : 8001
              }`
            )
          )
          return false
        }
        if (complexView) {
          await createComplexTrade(formData, brokersList, formAditionals, positionTableData).then(
            response => {
              if (response.success) {
                info(t('trades:forms.add.notifications.success.add'))
                history.push(NonAuthRoutes.tradesEdit, { trade: response.data, currentTab })
              } else {
                error(t('trades:forms.add.notifications.error.add'))
              }
            }
          )
        } else {
          const price: PriceConceptRequest | undefined =
            priceExpression && priceUnitSelected && priceCalculationTypeSelected && roundingSelected
              ? {
                  expression: priceExpression,
                  priceUnit: priceUnitSelected,
                  priceCalculationType: priceCalculationTypeSelected,
                  rounding: roundingSelected
                }
              : undefined

          if (price && !expressionValidated) {
            notifyError(t('trades:forms.add.notifications.error.errorExpression'))
          }
          await createSimpleTrade(formData, brokersList, formAditionals, price).then(response => {
            if (response.success) {
              info(t('trades:forms.add.notifications.success.add'))
              history.push(NonAuthRoutes.tradesEdit, { trade: response.data, currentTab })
            } else {
              error(t('trades:forms.add.notifications.error.add'))
            }
          })
        }
        return false
      } else {
        // if formData != undefined means user clicked on Save button but failed first validation due to ExpressionValidator inputs.
        !priceUnitSelected && notifyError(t('trades:forms.add.notifications.error.errorPriceUnit'))
        priceUnitSelected &&
          !roundingSelected &&
          notifyError(t('trades:forms.add.notifications.error.errorRounding'))
      }
      return false
    }
  }

  const onUpdateHandler = async (): Promise<any> => {
    if (validations.isDirty) {
      notifyError(t('trades:forms.add.notifications.error.validation'))
      return
    }
    if ((mainFormState && missingFieldsForm(sections, mainFormState)) || mainFormState === null) {
      notifyError(t('trades:forms.add.notifications.error.errorInvalidForm'))
      return false
    } else if (complexView && positionTableData.length < 1) {
      notifyError(t('trades:forms.add.notifications.error.errorPositionRequired'))
      return false
    }

    let refreshPage = false
    if (mainFormState && mainFormState.id && formStateAditionals && trade) {
      // For "simple trades" (1 position with 1 tract) we will call both PositionStrategy and TradeStrategy
      let positionStrategyResponse = true
      if (positionTableData.length === 1 && mode === FormMode.EDIT) {
        positionStrategyResponse = await validatePositionRulebook(
          positionTableData[0] as PosicionPrecio,
          trade.tradeId,
          mainFormState.counterpart!,
          { startDate: mainFormState.initDate, endDate: mainFormState.endDate },
          false
        ).then(res => {
          if (!res.success) {
            showErrorDetailListDialog(
              t('Error de rulebook'),
              res.error
                ? [{ code: res.error.code, message: `${res.error.message}` }]
                : [{ code: '412', message: '8001' }],
              t('tradesEdit:forms.errors.positionFormalizedOperations')
            )
          }
          return res.success
        })
      }

      if (!positionStrategyResponse) {
        return
      }

      const validateTradeRequest: ValidateTradeRulebookModel = {
        tradeId: trade ? trade.tradeId : 0,
        counterpartId: mainFormState.counterpart!,
        initDate: moment(mainFormState.initDate).format('YYYY-MM-DD')!,
        endDate: moment(mainFormState.endDate).format('YYYY-MM-DD')!,
        signDate: moment(mainFormState.signDate).format('YYYY-MM-DD')!
      }

      const checkTradeStrategy = await validateTradeRulebook(
        validateTradeRequest,
        positionTableData && positionTableData.length > 0 ? positionTableData : [],
        trade.counterpartId
      )
      if (checkTradeStrategy && !checkTradeStrategy.success) {
        showErrorDetailListDialog(
          t('Error de rulebook'),
          checkTradeStrategy.error
            ? [
                {
                  code: checkTradeStrategy.error.code,
                  message: `${checkTradeStrategy.error.message}`
                }
              ]
            : [{ code: '412', message: '8001' }]
        )
        return false
      }

      const pri: TradePricingDetails = {
        id: priceFields?.id,
        expression: priceFields?.priceExpression,
        priceCalculationType: enumKeyToValue(
          EnumPriceCalculationType,
          priceFields?.priceCalculationType
        ),
        currencyAndUnit: priceFields?.precioUnitario,
        rounding: priceFields?.redondeo,
        version: priceFields?.version
      }

      // Adding Brokers
      const formStateAditionalsWithBrokers = {
        ...formStateAditionals,
        brokers: brokersList.length > 0 ? brokersList : []
      }

      const updatedTrade = mapFormsToTradeDetails(
        mainFormState,
        pri,
        formStateAditionalsWithBrokers,
        positionTableData
      )
      let patchTradeResult: Partial<TradeDetailsRequest> | undefined =
        updatedTrade && originalTrade && updatedDiff(originalTrade, updatedTrade)

      if (!complexView && pri.id) {
        patchTradeResult = getUpdatePriceDates(patchTradeResult)
      }

      if (patchTradeResult && updatedTrade?.brokers && originalTrade?.brokers) {
        let changedBrokers: Broker[] = []
        originalTrade.brokers.forEach((broker, idx) => {
          const commercialId = broker.commercialId
          const index = brokersList.map(e => e.commercialId).indexOf(commercialId)
          //delete broker
          if (index === -1) {
            changedBrokers = [...changedBrokers, { ...broker, subjectId: null, commissionId: null }]
            //update broker
          } else if (
            brokersList[index].subjectId !== broker.subjectId ||
            brokersList[index].commissionId !== broker.commissionId
          ) {
            changedBrokers = [...changedBrokers, { ...brokersList[index] }]
          }
        })
        brokersList.forEach(newBroker => {
          if (!newBroker.hasOwnProperty('commercialId'))
            changedBrokers = [...changedBrokers, { ...newBroker }]
        })

        patchTradeResult.brokers = changedBrokers
      }

      // Converting updatedDiff result posicionesDelta: {{ id, ... }} into posicionesDelta: [{ id: ... }]
      const patchTradeRequest = patchTradeResult && convertDiffToModel(patchTradeResult)
      const request =
        originalTrade && mapToAPIRequest(patchTradeRequest, originalTrade, tradeResponse)

      if (request) {
        await patchTrade(originalTrade, request).then(response => {
          if (response.success) {
            refreshPage = true
          } else {
            error(t('tradesEdit:notifications.save.error'))
          }
        })
      }
    }
    if (
      typeof priceFields?.id === 'undefined' &&
      expressionValidated &&
      priceUnitSelected &&
      priceCalculationTypeSelected &&
      roundingSelected &&
      priceExpression &&
      !complexView &&
      tradeResponse?.positions &&
      tradeResponse?.positions.length === 1
    ) {
      await createPriceForPosition(tradeResponse.tradeId, tradeResponse.positions[0].idPosicion, {
        expression: priceExpression,
        priceCalculationType: priceCalculationTypeSelected,
        priceUnit: priceUnitSelected,
        rounding: roundingSelected,
        startDate: moment(tradeResponse.initDate).format('YYYY-MM-DD'),
        endDate: moment(tradeResponse.endDate).format('YYYY-MM-DD')
      }).then(response => {
        if (response.success) {
          refreshPage = true
        } else {
          error(t('tradesEdit:notifications.save.createPriceError'))
        }
      })
    }

    if (refreshPage) {
      info(t('tradesEdit:notifications.save.success'))
      fetchTrade()
      setPendingChanges(false)
    } else {
      history.push(NonAuthRoutes.trades)
      return false
    }
  }

  //#endregion

  const setFilterCurrencies = async (measureUnitId: any) => {
    const unitPricesByMeasure = unitPrices.filter(x => x.measureUnit === measureUnitId)
    const currenciesIdsFiltered = unitPricesByMeasure.flatMap(x => x.currency)
    let currenciesFiltered = formDependencies.currencies.filter(x =>
      currenciesIdsFiltered.includes(x.id)
    )
    if (measureUnitId === null) {
      currenciesFiltered = formDependencies.currencies
    }
    setFormDependencies(prevDep => ({
      ...prevDep,
      currenciesOptions: currenciesMapperToDropDown(currenciesFiltered)
    }))
  }

  const setFee = async (currencyId: number) => {
    let suffix: string | undefined
    if (currencyId) {
      const selectedCurrency = formDependencies.currencies.find(x => x.id === currencyId)
      suffix = selectedCurrency?.codCurrency
    }
    feeSuffix !== suffix && setFeeSuffix(suffix!)
  }

  const setFilterQuantityUnit = (currencyId: number) => {
    const filteredMeasureUnits = measureUnitsMapperToDropDown(
      filterMeasureUnits(currencyId, measureUnits, unitPrices)
    )
    setFormDependencies({ ...formDependencies, measureUnitsOptions: filteredMeasureUnits })
  }

  const updateFormStates = (
    trade: [TradeMainDetails, TradePricingDetails, TradeAditionalsDetails]
  ): void => {
    setMainFormState(trade[0])
    setValidCounterpart(trade[0]?.counterpart)
    setValidInitDate(trade[0]?.initDate)
    setValidEndDate(trade[0]?.endDate)
    setValidQuantity(trade[0]?.dailyQuantity)
    setValidPositionType(trade[0]?.type)
    setValidMeasureUnit(trade[0]?.dailyQuantityUnit)
    setPriceExpression(trade[1].expression)
    setPriceCalculationTypeSelected(
      trade[1]?.priceCalculationType
        ? enumValueToKey(EnumPriceCalculationType, trade[1].priceCalculationType)
        : undefined
    )
    setPriceUnitSelected(enumKeyToValue(EnumPrecioUnitario, trade[1].currencyAndUnit))
    setRoundingSelected(enumValueToKey(EnumRedondeo, trade[1].rounding))
    setPriceVersion(trade[1].version)
    setPriceFields({
      id: trade[1].id,
      priceExpression: trade[1].expression,
      precioUnitario: trade[1].currencyAndUnit,
      redondeo: trade[1].rounding,
      priceCalculationType: trade[1].priceCalculationType,
      version: trade[1].version
    })
    setFormStateAditionals(trade[2])
    trade[2]?.contract && updateBillingForTrade(trade[2])

    // if (trade[2] && trade[2]?.brokers && trade[2].brokers.length > 0) {
    //   updateComissionList(trade[2].brokers);
    // }
  }

  const checkDeliveryPoint = (deliveryPointId: number, deliveryPointDesc: string) => {
    const isDeliveryPointInList =
      formDependencies.deliveryPoints &&
      formDependencies.deliveryPoints.find(dp => dp.value === deliveryPointId)
    if (!isDeliveryPointInList) {
      setFormDependencies(prevDep => ({
        ...prevDep,
        deliveryPoints: [
          ...formDependencies.deliveryPoints,
          {
            value: deliveryPointId,
            label: deliveryPointDesc
          }
        ]
      }))
      setDeliveryPointEditable(false)
    }
  }

  const fetchDependencies = async () => {
    setIsFetchingDependencies(prevState => ({
      ...prevState,
      counterparts: true,
      balanceZones: true,
      tradeTypes: true,
      books: true,
      currencies: true,
      measureUnitsOptions: true,
      unitPrices: true
    }))
    await Promise.all([
      currentTab === TRADES_TABS.EXTENDED_CLIENT
        ? await fetchCounterPartsExtendedClients()
        : await fetchCounterParts(),
      await fetchTradeTypes(),
      await fetchBooks(),
      await fetchBrokers(),
      await fetchCurrencies(),
      await fetchEnergyMeasureUnits(),
      await fetchUnitPricesByEnergyType()
    ])
      .then(response => {
        setFormDependencies(prevDep => ({
          ...prevDep,
          counterparts: response[0],
          tradeTypes: response[1],
          books: response[2],
          brokers: response[3],
          currencies: response[4],
          currenciesOptions: currenciesMapperToDropDown(response[4]),
          measureUnitsOptions: measureUnitsMapperToDropDown(response[5]),
          unitPrices: response[6]
        }))
        setMeasureUnits(response[5])
        setUnitPrices(response[6])

        if (mode === FormMode.CREATE) {
          const defaultCounterpart = response[0] && response[0][0].value
          setMainFormState(prevState => ({ ...prevState, counterpart: +defaultCounterpart }))
        }
      })
      .catch(error => fetchDependencies())
      .finally(() =>
        setIsFetchingDependencies(prevState => ({
          ...prevState,
          counterparts: false,
          balanceZones: false,
          tradeTypes: false,
          books: false,
          currencies: false,
          measureUnitsOptions: false,
          unitPrices: false
        }))
      )
  }

  const updateDeliveryPoints = async (zone: number) => {
    if (currentTab !== TRADES_TABS.EXTENDED_CLIENT) {
      await fetchDeliveryPoints(zone).then(response => {
        setFormDependencies(prevDep => ({
          ...prevDep,
          deliveryPoints: response
        }))
      })
    } else if (
      currentTab === TRADES_TABS.EXTENDED_CLIENT &&
      formDependencies.deliveryPoints.length === 0
    ) {
      await fetchDeliveryPointsForExtendedClient(zone).then(response => {
        setFormDependencies(prevDep => ({
          ...prevDep,
          deliveryPoints: response
        }))

        setMainFormState(prevState => {
          return {
            ...prevState,
            deliveryPoint: response?.length > 0 ? +response[0]?.value : undefined
          }
        })
      })
    }
  }

  const updateContractsOptions = async (counterpartId: number, resetBilling: boolean) => {
    setIsFetchingDependencies(prevState => ({ ...prevState, contractOptions: true }))
    const contractsResponse =
      currentTab === TRADES_TABS.EXTENDED_CLIENT
        ? await fetchContractsForExtendedClient(counterpartId)
        : await fetchContracts(counterpartId)

    if (contractsResponse) {
      setContracts(contractsResponse)
      setFormDependencies(prevDep => ({
        ...prevDep,
        contractOptions: contractsMapperToDropDown(contractsResponse)
      }))
      if (contractsResponse.length > 0) {
        setContractDisabled(false)
      } else {
        setContractDisabled(true)
        setBillingLevelDisabled(true)
        setBillingCycleDisabled(true)
      }
      if (formStateAditionals && resetBilling) {
        setFormStateAditionals(prevState => ({
          ...prevState,
          contract: undefined,
          paymentMethod: undefined,
          billingLevel: undefined,
          billingCycleId: undefined
        }))
      }
    }

    setIsFetchingDependencies(prevState => ({ ...prevState, contractOptions: false }))
  }

  const getSelectedContract = (contractId: number | undefined): Contrato | null => {
    const selectedContract = contracts.find(contract => contract.id === contractId)
    setSelectedContract(selectedContract)
    formStateAditionals?.billingLevel &&
      selectedContract &&
      setBillingCycleForContract(formStateAditionals?.billingLevel)
    return selectedContract ? selectedContract : null
  }

  const setBillingCycleForContract = async (billingLevelId: number | null) => {
    // Contratos pueden tener CicloFacturacion tipo Trades o Cuentas.
    if (billingLevelId) {
      setIsFetchingDependencies(prevState => ({ ...prevState, invoiceCycles: true }))
      await fetchInvoiceCycles(billingLevelId).then(response => {
        const newOptions = invoiceCyclesMapperToDropDown(response)
        setBillingCycleOptions(prevState => [...newOptions])
      })
      setIsFetchingDependencies(prevState => ({ ...prevState, invoiceCycles: false }))
    } else {
      const billingLevelContratoId = enumEnumToValueNumber(
        EnumNivelCicloFacturacion,
        EnumNivelCicloFacturacion.Contrato
      )
      const billingLevelTradeId = enumEnumToValueNumber(
        EnumNivelCicloFacturacion,
        EnumNivelCicloFacturacion.Trade
      )
      if (billingLevelContratoId && billingLevelTradeId) {
        setIsFetchingDependencies(prevState => ({ ...prevState, invoiceCycles: true }))
        await fetchInvoiceCycles(billingLevelContratoId).then(response => {
          const newOptions = invoiceCyclesMapperToDropDown(response)
          setBillingCycleOptions(prevState => [...newOptions])
        })
        await fetchInvoiceCycles(billingLevelTradeId).then(response => {
          const newOptions = invoiceCyclesMapperToDropDown(response)
          setBillingCycleOptions(prevState => [...prevState, ...newOptions])
        })
        setIsFetchingDependencies(prevState => ({ ...prevState, invoiceCycles: false }))
      }
    }
  }

  const setBillingCycle = async (
    billingLevelId: number,
    billingCycleId?: number // optional parameter to use if we want to force a cycleId to be setup (ie: loading a trade with this prop not null)
  ) => {
    let cycle: number | undefined
    cycle = billingCycleId ? billingCycleId : undefined
    if (billingLevelId !== null) {
      if (billingLevelId === EnumNivelCicloFacturacion.Trade) {
        // If billingLevel is type Trade, we fetch Cycles with type "Trades".
        // If there's only 1 cycle we set the input as disabled, if not, it's enabled and setup with first option by default.
        await fetchInvoiceCycles(EnumTipoCicloFacturacion.Trades).then(response => {
          let cycleOptions = invoiceCyclesMapperToDropDown(response)
          setBillingCycleOptions(cycleOptions)
          if (cycleOptions.length > 0) {
            if (cycleOptions.length === 1) {
              setBillingCycleDisabled(true)
            } else {
              setBillingCycleDisabled(false)
            }
            // Only if BillingCycleId was not provided, we set the cycle as the first given option.
            cycle = billingCycleId ?? response[0].idCicloFacturacion
          }
        })
      } else {
        // If billingLevel is type Contrato, we just select the cycle from the selected/current contract.
        setBillingCycleDisabled(true)
        let invoices: SelectOption[] = []

        if (selectedContract) {
          let invoice = invoiceCycleMapperToDropDown(selectedContract?.cicloFacturacion!)
          invoices.push(invoice)
        }
        setBillingCycleOptions(invoices)
        // Only if BillingCycleId was not provided, we set the cycle as the first given option.
        cycle = billingCycleId ?? selectedContract?.cicloFacturacion?.idCicloFacturacion
      }
    }
    setFormStateAditionals(prevState => ({
      ...prevState,
      billingLevel: billingLevelId,
      billingCycleId: cycle
    }))
  }

  const setViewButtonState = (positions: NewPosicionPrecio[]) => {
    const viewButtonDisabledState = getViewButtonDisabledState(complexView, positions, {
      startDate: trade?.initDate,
      endDate: trade?.endDate
    })
    setViewButtonDisabled(viewButtonDisabledState)
  }

  const handleChangeView = () => {
    if (pendingChanges) {
      getConfirmation(ConfirmationDialogs.CHANGE_VIEW_DISCARD).then(async () => {
        setComplexView(prevState => !prevState)
        reloadPage()
        closeConfirmation()
      })
    } else {
      setComplexView(prevState => !prevState)
      savedTrade && resetPriceExpressionForm(savedTrade)
    }
  }

  const handleDiscard = () => {
    if ((!complexView && isPriceIncompleteOrInvalid()) || !pendingChanges) {
      if (goBackTo) {
        history.push(goBackTo)
      } else {
        history.push(NonAuthRoutes.trades)
      }
    } else {
      getConfirmation(ConfirmationDialogs.DISCARD_CHANGES).then(async () => {
        if (goBackTo) {
          history.push(goBackTo)
        } else {
          history.push(NonAuthRoutes.trades)
        }
        closeConfirmation()
      })
    }
  }

  const handleEditPosition = (position: NewPosicionPrecio) => {
    setPositionFormMode(FormMode.EDIT)
    setCurrentPosition(position)
    //const currentPoss = trade && trade.positions && trade.positions.length > 0 && trade.positions.find(p => p.idPosicion === position.idPosicion);
    //currentPoss && storeActivePosition(currentPoss);
    setShowAddPositionForm(true)
  }

  const handleDeletePosition = async (position: NewPosicionPrecio): Promise<boolean> => {
    let deleted = false
    await getConfirmation(ConfirmationDialogs.DELETE).then(async () => {
      if (mode === FormMode.CREATE) {
        onDeletePosition(position)
        closeConfirmation()
        deleted = true
        return deleted
      }
      const isFutureDate = await checkDateTimeLessThanRulebook(position.fechaInicio)
      if (!isFutureDate.success) {
        // If startDate is past-gas day, position cannot be deleted.
        notifyError(t('trades:positionTable.deletePosition.errorDeletePast'))
        closeConfirmation()
        return false
      }

      if (trade && position.idPosicion) {
        deleted = await deletePosition(trade.tradeId, position.idPosicion).then(async response => {
          if (response.success) {
            const response = await getTradeDetails(trade.tradeId)
            if (response.success && response.data) {
              setTrade(response.data)
              setSavedTrade(response.data)
              storeActiveTrade(response.data)
            }
            info(
              t('trades:positionTable.deletePosition.success', {
                positionCode: position?.codPosicion
              })
            )
            return true
          } else {
            notifyError(t('trades:positionTable.deletePosition.error'))
            return false
          }
        })
      }
      closeConfirmation()
    })
    return deleted
  }

  const setQuantityUnit = (measureUnitID: number) => {
    const measureUnit =
      formDependencies.measureUnitsOptions &&
      formDependencies.measureUnitsOptions.find(opt => opt.value === measureUnitID)
    if (measureUnit) {
      setQuantitySuffix(measureUnit.label)
    } else {
      // In case measure unit is not found in the list provided by backend, or the list is not ready yet (first render), we will use the static Enum.
      const measureUnitByEnum = enumEnumToValueString(EnumUnidadMedida, measureUnitID)
      setQuantitySuffix(measureUnitByEnum ?? '')
    }
  }

  // This logic is used to link PriceExpressionValidator's PriceUnit with selected currency+UnitMeasure
  // const setPriceUnit = (formState: any) => {
  //   if (formState.currency && formState.dailyQuantityUnit) {
  //     const selectedUnitPrice = unitPrices.find(
  //       x => x.currency === formState.currency && x.measureUnit === formState.dailyQuantityUnit
  //     );
  //     setQuantitySuffix(selectedUnitPrice?.descUnitPrice!);
  //     return;
  //   }
  // };

  const updatePositionTable = (positions: PosicionPrecio[]) => {
    const positionsList = formatPositionsForTable(positions, formDependencies.deliveryPoints)
    setPositionTableData(positionsList)
  }

  // Used as initial setup
  const updateBillingForTrade = (tradeAditionalsData: TradeAditionalsDetails) => {
    const contract = getSelectedContract(tradeAditionalsData.contract!)
    // contract && setBillingCycleForContract();
    setFormStateAditionals(prevState => ({
      ...prevState,
      contract: tradeAditionalsData.contract,
      paymentMethod: tradeAditionalsData.paymentMethod
    }))
    tradeAditionalsData?.billingLevel &&
      tradeAditionalsData?.billingCycleId &&
      contract &&
      setBillingCycle(tradeAditionalsData.billingLevel, tradeAditionalsData.billingCycleId)
  }

  // Used to update paymentMethod, billingLevel and billingCycle for a selected Contract.
  const updateBillingForContract = (contractId: number) => {
    const contract = getSelectedContract(contractId)
    // contract && setBillingCycleForContract();
    setFormStateAditionals(prevState => ({
      ...prevState,
      contract: contractId,
      paymentMethod:
        contract && contract?.metodoPago
          ? enumEnumToValueNumber(EnumTipoMetodoPago, contract.metodoPago.tipoMetodoPago)
          : null,
      billingLevel: contract ? EnumNivelCicloFacturacion.Contrato : null,
      billingCycleId: contract ? contract.cicloFacturacion?.idCicloFacturacion : null
    }))
  }

  const getComission = (commisions: SelectOption[]) => {
    if (commisions.length > 0) {
      onChangeCommissionsSelect(+commisions[0].value)
      if (commisions.length === 1) {
        setCommisionDisabled(true)
      } else {
        setCommisionDisabled(false)
      }
    } else {
      setCommisionDisabled(false)
    }
  }

  const updateComissionList = async (initialBrokers: Broker[]) => {
    setBrokersList(initialBrokers)
  }

  const setContractedProducts = async (brokers: Broker[]) => {
    let contractedProducts: any = []
    await brokers.forEach(async product => {
      if (product.subjectId) {
        await fetchContractedProducts(product.subjectId).then(response => {
          response.forEach(commission => contractedProducts.push(commission))
          if (contractedProducts.length === 1) {
            setCommisionDisabled(true)
          } else {
            setCommisionDisabled(false)
          }

          setFormDependencies(prevDep => ({
            ...prevDep,
            contractedProducts
          }))
        })
      }
    })
  }

  const onChangeBrokersSelect = async (subjectID: number) => {
    if (subjectID) {
      //setSelectedBroker(subjectID);
      let brokers: Broker[] = []
      if (brokersList.length > 0) {
        brokers = brokersList.map((broker, idx) => {
          if (idx === 0) {
            return {
              ...broker,
              subjectId: subjectID
            }
          } else return broker
        })
      } else {
        brokers.push({ subjectId: subjectID })
      }
      setBrokersList(brokers)
      await fetchContractedProducts(subjectID).then(products => {
        setFormDependencies(prevDep => ({
          ...prevDep,
          contractedProducts: products
        }))
        getComission(products)
      })
    } else {
      // Remove broker (+ commision)
      brokersList.length > 0 && setBrokersList([])
    }
    setPendingChanges(true)
  }

  const onChangeCommissionsSelect = (productID: number) => {
    // This function is trigger by the Select commision component AND by the getComission() (onChangeBrokersSelect) function.
    // That's why we need to map inside the setState to make sure we are using the updated state.
    setBrokersList(prevState => {
      let brokers: Broker[] = []
      if (prevState.length > 0) {
        brokers = prevState.map((broker, idx) => {
          if (idx === 0) {
            return {
              ...broker,
              commissionId: productID
            }
          } else return broker
        })
      } else {
        brokers.push({ commissionId: productID })
      }
      return brokers
    })
    setPendingChanges(true)
  }

  const validateInitDate = async (newInitDate: Date, counterpartId?: number) => {
    if (counterpartId) {
      const isCounterpartValid = await checkCreatePastTradeRulebook(counterpartId)
      const isFutureDate = await checkDateTimeLessThanRulebook(newInitDate)
      const formatInitDate = moment(newInitDate).format('YYYY-MM-DD')
      const formatValidInitDate = moment(validInitDate).format('YYYY-MM-DD')
      const formatEndDate = moment(mainFormState?.endDate).format('YYYY-MM-DD')
      if (isFutureDate.success) {
        // Future StartDate
        if (!isCounterpartValid.success) {
          // Counterpart is "Market/Mercado" or "Wholeseller/Mayorista"
          const isOperationFormalized =
            mainFormState && validInitDate && trade
              ? await checkStartDateTractRulebook(
                  trade.tradeId!,
                  trade?.positions[0].idPosicion!,
                  formatInitDate,
                  formatValidInitDate,
                  formatEndDate,
                  mainFormState.initDate,
                  mainFormState.endDate,
                  counterpartId
                )
              : null
          if (!isOperationFormalized?.success) {
            handleFormDirty(RulebookValidations.INIT_DATE, false, 'formalizedDate')
            return
          }
        }
      } else {
        // Past StartDate
        if (!isCounterpartValid.success) {
          // Counterpart is "Market/Mercado" or "Wholeseller/Mayorista"
          handleFormDirty(RulebookValidations.INIT_DATE, false, 'pastGasDayStartDate')
          return
        }
      }
      // StartDate is OK to be modified
      handleFormDirty(RulebookValidations.INIT_DATE, true)
      setValidInitDate(newInitDate)
    }
    if (
      mainFormState?.endDate &&
      newInitDate &&
      moment(mainFormState?.endDate).isBefore(moment(newInitDate), 'days')
    ) {
      handleFormDirty(RulebookValidations.INIT_DATE, false, 'tradeStartDate')
      return
    }
  }

  const validateEndDate = async (newEndDate: Date, counterpartId?: number) => {
    if (
      mainFormState?.initDate &&
      newEndDate &&
      moment(mainFormState?.initDate).isAfter(moment(newEndDate), 'days')
    ) {
      handleFormDirty(RulebookValidations.END_DATE, false, 'tradeEndDate')
      return
    }
    if (counterpartId) {
      const isFutureDate = await checkDateTimeLessThanRulebook(newEndDate)
      if (isFutureDate.success) {
        // Future EndDate
        const isOperationFormalized =
          mainFormState && validInitDate && trade
            ? await checkEndDateTractRulebook(
                trade.tradeId!,
                trade?.positions[0].idPosicion!,
                newEndDate,
                validInitDate,
                validEndDate,
                mainFormState.initDate,
                mainFormState.endDate,
                counterpartId
              )
            : null
        if (!isOperationFormalized?.success) {
          // Counterpart is "Market/Mercado" or "Wholeseller/Mayorista"
          handleFormDirty(RulebookValidations.END_DATE, false, 'formalizedDate')
          return
        }
      } else {
        // Past EndDate
        const isCounterpartValid = await checkCreatePastTradeRulebook(counterpartId)
        if (!isCounterpartValid.success) {
          // Counterpart is "Market/Mercado" or "Wholeseller/Mayorista"
          handleFormDirty(RulebookValidations.END_DATE, false, 'pastGasDayEndDate')
          return
        }
      }
      // EndDate is OK to be modified
      handleFormDirty(RulebookValidations.END_DATE, true)
      setPendingChanges(true)
    }
  }

  const handleFormDirty = (validation: RulebookValidations, valid: boolean, cause?: string) => {
    setValidations(prevValidations => {
      const newValidation = { ...prevValidations, [validation]: valid }
      const isDirty = !(
        newValidation.initDate &&
        newValidation.endDate &&
        newValidation.counterpart &&
        newValidation.quantity &&
        newValidation.deliveryPoint &&
        newValidation.signDate &&
        newValidation.positionType &&
        newValidation.measureUnit
      )
      return { ...newValidation, isDirty: isDirty }
    })

    if (validation === RulebookValidations.INIT_DATE) {
      cause && !valid ? setStartDateMsgError(cause) : setStartDateMsgError(undefined)
    } else if (validation === RulebookValidations.END_DATE) {
      cause && !valid ? setEndDateMsgError(cause) : setEndDateMsgError(undefined)
    } else if (validation === RulebookValidations.QUANTITY) {
      cause && !valid ? setQuantityMsgError(cause) : setQuantityMsgError(undefined)
    }
  }

  const restoreErrors = () => {
    setValidations(initialValidations)
    setQuantityMsgError(undefined)
    setStartDateMsgError(undefined)
    setEndDateMsgError(undefined)
  }

  const resetPriceExpressionForm = (savedTrade?: TradeDetailsResponse) => {
    if (savedTrade && savedTrade.positions[0]) {
      const price = savedTrade.positions[0].price
      setPriceFields({
        id: price?.id,
        priceExpression: price?.expression,
        precioUnitario: price?.priceUnit,
        redondeo: price?.rounding,
        priceCalculationType: price?.priceCalculationType,
        version: price?.version
      })
      setPriceExpression(price?.expression)
      setPriceCalculationTypeSelected(
        price?.priceCalculationType
          ? enumValueToKey(EnumPriceCalculationType, price.priceCalculationType)
          : undefined
      )
      setPriceUnitSelected(enumKeyToValue(EnumPrecioUnitario, price?.priceUnit))
      setRoundingSelected(enumValueToKey(EnumRedondeo, price?.rounding))
    } else {
      setPriceFields(undefined)
      setPriceExpression(undefined)
      setPriceCalculationTypeSelected(null)
      setPriceUnitSelected(undefined)
      setRoundingSelected(undefined)
    }
  }

  // Used to reload the screen to initial values.
  const reloadPage = () => {
    // If in Create Trade mode, all forms and components get restored to initial values.
    if (mode === FormMode.CREATE) {
      // Restore components states
      const defaultCounterpart =
        formDependencies &&
        formDependencies.counterparts &&
        formDependencies.counterparts.length > 0
          ? +formDependencies.counterparts[0].value
          : undefined
      setMainFormState({
        ...initialValues,
        counterpart: defaultCounterpart
      })
      resetPriceExpressionForm()
      setPositionTableData([])
      setFormStateAditionals({})
      setQuantitySuffix('')
      setBrokersList([])
      setIsSimpleCommission(true)
    } else if (mode === FormMode.EDIT) {
      if (savedTrade && simple) {
        const measureUnitID = parseInt(EnumUnidadMedida[savedTrade.positions[0].unidadMedida])
        // const selectedUnitPrice = unitPrices.find(
        //   x => x.currency === savedTrade.currency && x.measureUnit === measureUnitID
        // );
        setQuantityUnit(measureUnitID)
      }

      fetchTrade()
      setBrokersList(tradeData?.brokers || [])
      setIsSimpleCommission(!(tradeData && tradeData.brokers && tradeData.brokers.length > 1))
    }
    // Clean all Rulebooks errors
    restoreErrors()
    // Clean pending changes
    setPendingChanges(false)
  }

  const updateSimplePositionList = (
    list: NewPosicionPrecio[],
    prop: string,
    value: any
  ): NewPosicionPrecio[] => {
    return list.map((position, idx) => {
      if (idx === 0) {
        const updatedPoss: NewPosicionPrecio = {
          ...position,
          [prop]: value,
          tramos: [{ ...position.tramos[0], [prop]: value }]
        }
        return updatedPoss
      } else return position
    })
  }

  //#region Form definition

  const sections: Section[] = [
    {
      title: t('tradesEdit:forms.sections.trade.title'),
      inputs: [
        {
          name: 'description',
          label: t('tradesEdit:forms.sections.trade.inputs.description'),
          type: DataType.TEXT,
          readOnly: !editMode,
          inputSize: !complexView ? 4 : 6,
          onBlur: (value: any) => {
            setMainFormState({ ...mainFormState, description: value })
            setPendingChanges(true)
          }
        },
        {
          name: 'counterpart',
          label: t('tradesEdit:forms.sections.trade.inputs.counterpart'),
          type: DataType.SELECT,
          selectOptions: formDependencies.counterparts,
          required: true,
          isLoading: isFetchingDependencies.counterparts,
          inputSize: complexView ? 6 : undefined,
          readOnly: !(editMode && counterpartEditable),
          errorState: !validations.counterpart,
          errorText: !validations.counterpart ? t('tradesEdit:forms.errors.counterpart') : '',
          onChange: async (newCounterpart: any, formData) => {
            if (mode === FormMode.CREATE) {
              handleFormDirty(RulebookValidations.COUNTERPART, true)
              setValidCounterpart(newCounterpart)
              setPendingChanges(true)
              setMainFormState({ ...mainFormState, counterpart: newCounterpart })
              updateContractsOptions(newCounterpart, true)
              return
            } else if (mode === FormMode.EDIT) {
              if (newCounterpart === savedTrade?.counterpartId) {
                // If value is restore to original one, we skip any validations and remove error.
                handleFormDirty(RulebookValidations.COUNTERPART, true)
                updateContractsOptions(newCounterpart, true)
                setMainFormState({ ...mainFormState, counterpart: newCounterpart })
                setValidCounterpart(newCounterpart)
                trade &&
                  mainFormState?.id &&
                  mainFormState?.positionId &&
                  enumEnumToValueNumber(PositionType, mainFormState?.type) !==
                    enumEnumToValueNumber(EnumTipoPosicion, savedTrade?.type) &&
                  newCounterpart &&
                  (await checkPositionTypeRulebook(
                    trade.tradeId,
                    mainFormState.positionId,
                    newCounterpart
                  ).then(async response => {
                    if (response.success) {
                      // if Rulebook validates, then we update the form:
                      handleFormDirty(RulebookValidations.POSITION_TYPE, true)
                    } else if (response.error) {
                      handleFormDirty(RulebookValidations.POSITION_TYPE, false)
                    }
                  }))
              } else {
                mainFormState?.id &&
                  validCounterpart &&
                  (await checkCounterpartRulebook(mainFormState.id, validCounterpart).then(
                    async response => {
                      if (response.success) {
                        // if Rulebook validates, then we update the form:
                        handleFormDirty(RulebookValidations.COUNTERPART, true)
                        setValidCounterpart(newCounterpart)
                        setPendingChanges(true)
                        setMainFormState({ ...mainFormState, counterpart: newCounterpart })
                        updateContractsOptions(newCounterpart, true)
                      } else if (response.error) {
                        handleFormDirty(RulebookValidations.COUNTERPART, false)
                        setMainFormState({ ...mainFormState, counterpart: newCounterpart })
                      } else {
                        // error de api
                      }
                    }
                  ))
              }
              mainFormState?.initDate &&
                !initDateDisabled &&
                validateInitDate(mainFormState.initDate, newCounterpart)
              mainFormState?.endDate &&
                !endDateDisabled &&
                validateEndDate(mainFormState.endDate, newCounterpart)
            }
          }
        },
        {
          name: 'balanceZone',
          label: t('tradesEdit:forms.sections.trade.inputs.balanceZone'),
          type: DataType.SELECT,
          selectOptions: formDependencies.balanceZones,
          required: true,
          isLoading: isFetchingDependencies.balanceZones,
          display: !complexView,
          inputSize: !complexView ? 2 : undefined,
          defaultValue: activeBalanceZone?.id,
          readOnly: !(editMode && balanceZoneEditable)
            ? true
            : formDependencies.balanceZones.length > 1
              ? false
              : true,
          onChange: async (value: any) => {
            // Every time Balance Zone is changed, we need to re-fetch the delivery Points for that zone.
            setPendingChanges(true)
            updateDeliveryPoints(value)
            setMainFormState({ ...mainFormState, balanceZone: value })
            if (positionTableData.length === 1 && !complexView) {
              setPositionTableData(list => {
                return list.map((position, idx) => {
                  if (idx === 0) {
                    const updatedPoss: NewPosicionPrecio = {
                      ...position,
                      zonaBalance: value
                    }
                    return updatedPoss
                  } else return position
                })
              })
            }
          }
        },
        {
          name: 'deliveryPoint',
          label: t('tradesEdit:forms.sections.trade.inputs.deliveryPoint'),
          type: DataType.SELECT,
          selectOptions: formDependencies.deliveryPoints,
          readOnly: !(editMode && deliveryPointEditable),
          display: !complexView && currentTab !== TRADES_TABS.EXTENDED_CLIENT,
          required: true,
          errorState: !validations.deliveryPoint,
          errorText: !validations.deliveryPoint ? t('tradesEdit:forms.errors.logElement') : '',
          onChange: async (newId: any) => {
            if (mode === FormMode.CREATE) {
              handleFormDirty(RulebookValidations.DELIVERY_POINT, true)
              setPendingChanges(true)
              setMainFormState({ ...mainFormState, deliveryPoint: newId })
              return
            } else if (mode === FormMode.EDIT) {
              if (
                complexView ||
                (savedTrade?.positions &&
                  savedTrade?.positions[0].puntoEntrega &&
                  +newId !== savedTrade.positions[0].puntoEntrega.id)
              ) {
                mainFormState?.id &&
                  mainFormState?.positionId &&
                  (await checkLogElementRulebook(
                    mainFormState.id,
                    mainFormState.positionId,
                    newId,
                    savedTrade!.positions[0]!.puntoEntrega!.id!
                  ).then(async response => {
                    if (response.success) {
                      // if Rulebook validates, then we update the form:
                      handleFormDirty(RulebookValidations.DELIVERY_POINT, true)
                      setPendingChanges(true)
                    } else {
                      handleFormDirty(RulebookValidations.DELIVERY_POINT, false)
                    }
                    setMainFormState({ ...mainFormState, deliveryPoint: newId })
                  }))
              } else {
                handleFormDirty(RulebookValidations.DELIVERY_POINT, true)
              }
            }
            if (positionTableData.length === 1 && !complexView) {
              setPositionTableData(list => {
                return list.map((position, idx) => {
                  if (idx === 0) {
                    const updatedPoss: NewPosicionPrecio = {
                      ...position,
                      puntoEntrega: { id: +newId }
                    }
                    return updatedPoss
                  } else return position
                })
              })
            }
          }
        },
        {
          name: 'initDate',
          label: t('tradesEdit:forms.sections.trade.inputs.initDate'),
          type: DataType.DATE,
          readOnly: !editMode || initDateDisabled,
          errorState: !validations.initDate,
          errorText:
            !validations.initDate && startDateMsgError ? getErrorText(startDateMsgError) : '',
          required: true,
          inputSize: 2,
          onBlur: async (newInitDate: any) => {
            setMainFormState(prevState => {
              const total = getTotalQuantity({ ...prevState, initDate: newInitDate })
              return { ...prevState, initDate: newInitDate, totalQuantity: total }
            })
            let tractsList: NewTramo[] = []
            if (positionTableData.length === 1 && !complexView) {
              const updatedPositionList = updateSimplePositionList(
                positionTableData,
                'fechaInicio',
                newInitDate
              )
              tractsList = updatedPositionList.length === 1 ? updatedPositionList[0].tramos : []
              setPositionTableData(updatedPositionList)
            }

            if (moment(newInitDate).isSame(moment(trade?.initDate), 'days')) {
              handleFormDirty(RulebookValidations.INIT_DATE, true)
            }
            if (
              mainFormState?.endDate &&
              moment(mainFormState?.endDate).isBefore(moment(newInitDate), 'days')
            ) {
              handleFormDirty(RulebookValidations.INIT_DATE, false, 'tradeStartDate')
              return
            } else {
              handleFormDirty(RulebookValidations.INIT_DATE, true)
              handleFormDirty(RulebookValidations.END_DATE, true)
            }

            if (mode === FormMode.CREATE) {
              setValidInitDate(newInitDate)
              setPendingChanges(true)
            } else if (mode === FormMode.EDIT) {
              setPendingChanges(true)
              // Check if endDate error has to be cleaned
              mainFormState?.endDate &&
                moment(mainFormState?.endDate).isSameOrAfter(moment(newInitDate), 'days') &&
                endDateMsgError === 'tradeEndDate' &&
                handleFormDirty(RulebookValidations.END_DATE, true)
            }
            // Either in Create or Edit mode, we check if sign date is valid for the new start date:
            if (
              mainFormState?.signDate &&
              moment(mainFormState?.signDate).isAfter(moment(newInitDate), 'days')
            ) {
              handleFormDirty(RulebookValidations.SIGN_DATE, false)
            } else {
              handleFormDirty(RulebookValidations.SIGN_DATE, true)
            }
          }
        },
        {
          name: 'endDate',
          label: t('tradesEdit:forms.sections.trade.inputs.endDate'),
          type: DataType.DATE,
          readOnly: !editMode || endDateDisabled,
          required: true,
          errorState: !validations.endDate,
          errorText: !validations.endDate && endDateMsgError ? getErrorText(endDateMsgError) : '',
          inputSize: 2,
          onBlur: async (newEndDate: any) => {
            setMainFormState(prevState => {
              const total = getTotalQuantity({ ...prevState, endDate: newEndDate })
              return { ...prevState, endDate: newEndDate, totalQuantity: total }
            })
            let tractsList: NewTramo[] = []
            if (positionTableData.length === 1 && !complexView) {
              const updatedPositionList = updateSimplePositionList(
                positionTableData,
                'fechaFin',
                newEndDate
              )
              tractsList = updatedPositionList.length === 1 ? updatedPositionList[0].tramos : []
              setPositionTableData(updatedPositionList)
            }

            if (moment(newEndDate).isSame(moment(trade?.endDate), 'days')) {
              handleFormDirty(RulebookValidations.END_DATE, true)
            }
            if (
              mainFormState?.initDate &&
              moment(newEndDate).isBefore(moment(mainFormState?.initDate), 'days')
            ) {
              handleFormDirty(RulebookValidations.END_DATE, false, 'tradeEndDate')
              return
            } else {
              startDateMsgError === 'tradeStartDate' &&
                handleFormDirty(RulebookValidations.INIT_DATE, true)
              handleFormDirty(RulebookValidations.END_DATE, true)
            }

            if (mode === FormMode.CREATE) {
              setValidEndDate(newEndDate)
              setPendingChanges(true)
            } else if (mode === FormMode.EDIT) {
              setPendingChanges(true)
            }
          }
        },
        {
          name: 'signDate',
          label: t('tradesEdit:forms.sections.trade.inputs.signDate'),
          type: DataType.DATETIME,
          readOnly: !editMode,
          errorState: !validations.signDate,
          errorText: !validations.signDate ? t('tradesEdit:forms.errors.signDate') : '',
          required: true,
          inputSize: 3,
          onBlur: (value: any) => {
            if (
              value &&
              mainFormState?.initDate &&
              moment(value).isAfter(moment(mainFormState?.initDate), 'days')
            ) {
              handleFormDirty(RulebookValidations.SIGN_DATE, false)
            } else {
              handleFormDirty(RulebookValidations.SIGN_DATE, true)
            }
            setPendingChanges(true)
            setMainFormState({ ...mainFormState, signDate: value })
          }
        },
        {
          name: 'type',
          label: t('tradesEdit:forms.sections.trade.inputs.type'),
          type: DataType.SELECT,
          selectOptions: enumToSelectOptionArrayDefaultValues(PositionType, 'enums:PositionType', [
            PositionType.Sale,
            PositionType.Purchase
          ]),
          readOnly: !(editMode && typeEditable),
          required: true,
          inputSize: !complexView ? 2 : undefined,
          display: !complexView,
          errorState: !validations.positionType,
          errorText: !validations.positionType ? t('tradesEdit:forms.errors.positionType') : '',
          onChange: async newType => {
            if (mode === FormMode.CREATE) {
              setPendingChanges(true)
              setValidPositionType(+newType)
              handleFormDirty(RulebookValidations.POSITION_TYPE, true)
              return
            } else if (mode === FormMode.EDIT) {
              // If trade is simple, we check only if new type is different than original (saved) one.
              if (
                complexView ||
                (savedTrade?.positions &&
                  +newType !==
                    enumEnumToValueNumber(EnumTipoPosicion, savedTrade?.positions[0].tipoPosicion))
              ) {
                trade &&
                  mainFormState?.id &&
                  mainFormState?.positionId &&
                  mainFormState?.counterpart &&
                  (await checkPositionTypeRulebook(
                    trade.tradeId,
                    mainFormState.positionId,
                    mainFormState.counterpart
                  ).then(async response => {
                    if (response.success) {
                      // if Rulebook validates, then we update the form:
                      setPendingChanges(true)
                      setValidPositionType(+newType)
                      handleFormDirty(RulebookValidations.POSITION_TYPE, true)
                    } else if (response.error) {
                      handleFormDirty(RulebookValidations.POSITION_TYPE, false)
                    } else {
                      // error de api
                    }
                  }))
              } else {
                handleFormDirty(RulebookValidations.POSITION_TYPE, true)
              }
            }
            if (positionTableData.length === 1 && !complexView) {
              setPositionTableData(list => {
                return list.map((position, idx) => {
                  if (idx === 0) {
                    const updatedPoss: NewPosicionPrecio = {
                      ...position,
                      tipoPosicion: +newType
                    }
                    return updatedPoss
                  } else return position
                })
              })
            }
          }
        },
        {
          name: 'state',
          label: t('tradesEdit:forms.sections.trade.inputs.state'),
          type: DataType.SELECT,
          selectOptions: enumToSelectOptionArray(ValidationType, 'enums:ValidationType'),
          readOnly: !editMode,
          required: true,
          inputSize: !complexView ? 3 : 3,
          onChange: (value: any, formData) => {
            setMainFormState({ ...mainFormState, state: value })
            setPendingChanges(true)
          }
        },
        {
          name: 'dailyQuantityUnit',
          label: t('tradesEdit:forms.sections.trade.inputs.dailyQuantityUnit'),
          type: DataType.SELECT,
          selectOptions: formDependencies.measureUnitsOptions,
          readOnly: mode === FormMode.EDIT && !(editMode && unitMeasuresEditable),
          display: !complexView,
          required: true,
          inputSize: !complexView ? 2 : undefined,
          clearable: true,
          isLoading: isFetchingDependencies.measureUnitsOptions,
          errorState: !validations.measureUnit,
          errorText: !validations.measureUnit ? t('tradesEdit:forms.errors.measureUnit') : '',
          onChange: async (measureUnitID: any, formState: any) => {
            if (positionTableData.length === 1 && !complexView) {
              setPositionTableData(list => {
                return list.map((position, idx) => {
                  if (idx === 0) {
                    const updatedPoss: NewPosicionPrecio = {
                      ...position,
                      unidadMedida: enumEnumToValueString(EnumUnidadMedida, measureUnitID)!
                    }
                    return updatedPoss
                  } else return position
                })
              })
            }

            if (mode === FormMode.CREATE) {
              setPendingChanges(true)
              setValidMeasureUnit(measureUnitID)
              handleFormDirty(RulebookValidations.MEASURE_UNIT, true)
            } else if (measureUnitID === validMeasureUnit) {
              handleFormDirty(RulebookValidations.MEASURE_UNIT, true)
            } else if (mode === FormMode.EDIT && measureUnitID !== validMeasureUnit) {
              mainFormState?.id &&
                mainFormState?.positionId &&
                mainFormState?.counterpart &&
                mainFormState?.initDate &&
                mainFormState?.dailyQuantity !== null &&
                mainFormState?.dailyQuantity !== undefined &&
                validQuantity &&
                (await checkQuantityRulebook(
                  mainFormState.positionId,
                  mainFormState.counterpart,
                  mainFormState.initDate,
                  validQuantity * 2,
                  mainFormState.endDate,
                  validQuantity
                ).then(async response => {
                  if (response.success) {
                    // if Rulebook validates, then we update the form:
                    setPendingChanges(true)
                    setValidMeasureUnit(measureUnitID)
                    handleFormDirty(RulebookValidations.MEASURE_UNIT, true)
                  } else if (response.error) {
                    handleFormDirty(RulebookValidations.MEASURE_UNIT, false)
                  } else {
                    // error de api
                  }
                }))
            }
            setFilterCurrencies(measureUnitID)
            setMainFormState({ ...mainFormState, dailyQuantityUnit: measureUnitID })
            setFee(formState)
            setQuantityUnit(measureUnitID)
            setPendingChanges(true)
          }
        },
        {
          name: 'currency',
          label: t('tradesEdit:forms.sections.trade.inputs.currency'),
          type: DataType.SELECT,
          selectOptions: formDependencies.currenciesOptions,
          isLoading: isFetchingDependencies.currencies,
          readOnly: !editMode,
          required: true,
          inputSize: !complexView ? 2 : 2,
          defaultValue: 1,
          onChange: (value, formState) => {
            setFilterQuantityUnit(+value)
            setFee(+value)
            setMainFormState({ ...mainFormState, currency: +value })
            setPendingChanges(true)
          }
        },
        {
          name: 'dailyQuantity',
          label: t('tradesEdit:forms.sections.trade.inputs.dailyQuantity'),
          type: DataType.NUMBER,
          customDecimalScale: quantityDecimals,
          required: true,
          display: !complexView,
          readOnly: !(editMode && dailyQuantityEditable),
          inputSize: !complexView ? 3 : undefined,
          suffix: quantitySuffix,
          errorState: !validations.quantity,
          errorText:
            !validations.quantity && quantityMsgError ? getErrorText(quantityMsgError) : '',
          onBlur: async newQuantity => {
            let tractsList: NewTramo[] = []
            if (positionTableData.length === 1 && !complexView) {
              const updatedPositionList = updateSimplePositionList(
                positionTableData,
                'cantidadDiaria',
                formatStringNumber(newQuantity as string)
              )
              tractsList = updatedPositionList.length === 1 ? updatedPositionList[0].tramos : []
              setPositionTableData(list => {
                return updateSimplePositionList(
                  list,
                  'cantidadDiaria',
                  formatStringNumber(newQuantity as string)
                )
              })
            }

            if (mode === FormMode.CREATE) {
              setPendingChanges(true)
              setValidQuantity(formatStringNumber(newQuantity as string))
              handleFormDirty(RulebookValidations.QUANTITY, true)
            } else if (mode === FormMode.EDIT) {
              if (!complexView && trade && tradeSimpleSameDates(trade)) {
                const response =
                  tractsList.length > 0 &&
                  (await checkPresentFutureDatesRulebook(
                    trade?.tradeId!,
                    trade?.positions[0].idPosicion!,
                    mainFormState?.counterpart!,
                    tractsList!
                  ).then(response => {
                    if (!response.success) {
                      handleFormDirty(
                        RulebookValidations.QUANTITY,
                        false,
                        t('tradesEdit:forms.errors.quantityFormalizedOperations')
                      )
                    } else {
                      handleFormDirty(RulebookValidations.QUANTITY, true)
                      setPendingChanges(true)
                    }
                    return response.success
                  }))
              }
            }
          }
        },
        {
          name: 'totalQuantity',
          label: t('tradesEdit:forms.sections.trade.inputs.totalQuantity'),
          type: DataType.NUMBER,
          customDecimalScale: quantityDecimals,
          readOnly: true,
          inputSize: !complexView ? 3 : undefined,
          display: !complexView,
          suffix: quantitySuffix
        },
        {
          name: 'fee',
          label: t('tradesEdit:forms.sections.trade.inputs.fee'),
          type: DataType.NUMBER,
          decimalScale: DecimalScale.DEFAULT,
          readOnly: !editMode,
          display: !complexView,
          suffix: feeSuffix,
          inputSize: !complexView ? 2 : undefined,
          onBlur: (newFee: any) => {
            setMainFormState({
              ...mainFormState,
              fee: parseGroupedFloat(String(newFee))
            })
            if (positionTableData.length === 1 && !complexView) {
              setPositionTableData(list => {
                return list.map((position, idx) => {
                  if (idx === 0) {
                    const updatedPoss: NewPosicionPrecio = {
                      ...position,
                      tramos:
                        position.tramos && position.tramos[0]
                          ? [{ ...position.tramos[0], fee: parseGroupedFloat(String(newFee)) }]
                          : [
                              {
                                fechaInicio: position.fechaInicio,
                                fechaFin: position.fechaFin,
                                cantidadDiaria: position.cantidadDiaria,
                                fee: parseGroupedFloat(String(newFee))
                              }
                            ]
                    }
                    return updatedPoss
                  } else return position
                })
              })
            }
            setPendingChanges(true)
          }
        }
      ]
    }
  ]

  const sectionsAditionals: Section[] = [
    {
      title: '',
      collapsible: true,
      inputs: []
    },
    {
      title: t('tradesEdit:forms.sections.segmentation.title'),
      collapsible: true,
      inputs: [
        {
          name: 'category',
          label: t('tradesEdit:forms.sections.segmentation.inputs.category'),
          type: DataType.SELECT,
          selectOptions: formDependencies.tradeTypes,
          required: false,
          readOnly: !editMode,
          clearable: true,
          onChange: (value: any, formState: any) => {
            setFormStateAditionals({ ...formStateAditionals, category: value })
            setPendingChanges(true)
          }
        },
        {
          name: 'book',
          label: t('tradesEdit:forms.sections.segmentation.inputs.book'),
          type: DataType.SELECT,
          selectOptions: formDependencies.books,
          required: false,
          readOnly: !editMode,
          clearable: true,
          onChange: (value: any, formState: any) => {
            setFormStateAditionals({ ...formStateAditionals, book: value })
            setPendingChanges(true)
          }
        }
      ]
    },
    {
      title: t('tradesEdit:forms.sections.billing.title'),
      collapsible: true,
      inputs: [
        {
          name: 'contract',
          label: t('tradesEdit:forms.sections.billing.inputs.contract'),
          type: DataType.SELECT,
          selectOptions: formDependencies.contractOptions,
          required: false,
          readOnly: contractDisabled || !editMode,
          clearable: true,
          isLoading: isFetchingDependencies.contractOptions,
          loadingText: t('tradesEdit:forms.sections.billing.loading.contract'),
          onChange: async (selectedContractId: any, formState: any) => {
            if (selectedContractId === null) {
              setBillingLevelDisabled(true)
              setBillingCycleDisabled(true)
            } else {
              setBillingLevelDisabled(false)
              setBillingCycleDisabled(false)
            }
            updateBillingForContract(selectedContractId)
            setPendingChanges(true)
          }
        },
        {
          name: 'paymentMethod',
          label: t('tradesEdit:forms.sections.billing.inputs.paymentMethod'),
          type: DataType.SELECT,
          selectOptions: enumToSelectOptionArray(EnumTipoMetodoPago, 'enums:EnumTipoMetodoPago'),
          required: false,
          readOnly: true,
          onChange: (value: any, formState: any) => {
            setFormStateAditionals({ ...formStateAditionals, paymentMethod: value })
            setPendingChanges(true)
          }
        },
        {
          name: 'billingLevel',
          label: t('tradesEdit:forms.sections.billing.inputs.billingLevel'),
          type: DataType.SELECT,
          readOnly: billingLevelDisabled || !editMode,
          required: false,
          selectOptions: enumToSelectOptionArrayDefaultValues(
            EnumNivelCicloFacturacion,
            'enums:EnumNivelCicloFacturacion',
            [EnumNivelCicloFacturacion.Contrato, EnumNivelCicloFacturacion.Trade]
          ),
          onChange: async (selectedBillingLevel: any, formState: any) => {
            setBillingCycle(selectedBillingLevel)
            setPendingChanges(true)
          }
        },
        {
          name: 'billingCycleId',
          label: t('tradesEdit:forms.sections.billing.inputs.billingCycle'),
          type: DataType.SELECT,
          selectOptions: billingCycleOptions,
          required: false,
          readOnly:
            billingCycleDisabled ||
            formStateAditionals?.billingLevel === EnumNivelCicloFacturacion.Contrato ||
            !editMode,
          clearable: true,
          isLoading: isFetchingDependencies.contractOptions || isFetchingDependencies.invoiceCycles,
          loadingText: t('tradesEdit:forms.sections.billing.loading.billingCycle'),
          onChange: (value: any, formState: any) => {
            setFormStateAditionals({ ...formStateAditionals, billingCycleId: value })
            setPendingChanges(true)
          }
        }
      ]
    },
    {
      title: t('tradesEdit:forms.sections.comments.title'),
      collapsible: true,
      inputs: [
        {
          name: 'comments',
          label: t('tradesEdit:forms.sections.comments.inputs.comments'),
          type: DataType.TEXT,
          required: false,
          readOnly: !editMode,
          inputSize: 6,
          onChange: (value: any, formState: any) => {
            setFormStateAditionals({ ...formStateAditionals, comments: value })
            setPendingChanges(true)
          }
        }
      ]
    }
  ]

  const options: FormOptions = {
    elevation: 1,
    columns: 4,
    analytics: {
      customer: getCustomerDomain(),
      view: t('tradesEdit:forms.analytics.simple')
    }
  }

  const optionsAditionals: FormOptions = {
    elevation: 1,
    columns: 4,
    analytics: {
      customer: getCustomerDomain(),
      view: t('tradesEdit:forms.analytics.simple')
    }
  }

  const validateDates = async () => {
    if (trade?.initDate && trade?.endDate && trade?.counterpartId) {
      const checkResponse = await checkDates(trade?.initDate, trade?.endDate, trade?.counterpartId)
      checkResponse.propsNeedToBeDisabled && checkResponse.startDateIsPast
        ? setInitDateDisabled(true)
        : setInitDateDisabled(false)
      checkResponse.propsNeedToBeDisabled && checkResponse.endDateIsPast
        ? setEndDateDisabled(true)
        : setEndDateDisabled(false)
      if (checkResponse.propsNeedToBeDisabled) {
        setUnitMeasuresEditable(false)
        setDailyQuantityEditable(false)
        setCounterpartEditable(false)
        setDeliveryPointEditable(false)
        setBalanceZoneEditable(false)
        setTypeEditable(false)
        setUnitMeasuresEditable(false)
      }
    }
  }

  useEffect(() => {
    fetchDependencies()
    const zones = getBalanceZonesForCompany()
    const availableBalanceZones = zones ? balanceZonesMapperToDropDown(zones) : []
    setFormDependencies(prevDep => ({ ...prevDep, balanceZones: availableBalanceZones }))
    activeBalanceZone && updateDeliveryPoints(activeBalanceZone?.id)

    if (mode === FormMode.EDIT) {
      savedTrade && initialMapper(savedTrade)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Will trigger after creating/modifying/deleting a Position
  useEffect(() => {
    if (trade) {
      initialMapper(trade)
      trade && trade?.initDate && trade?.counterpartId && mode === FormMode.EDIT && validateDates()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trade])

  useEffect(() => {
    mainFormState?.balanceZone && updateDeliveryPoints(mainFormState?.balanceZone)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainFormState?.balanceZone])

  useEffect(() => {
    positionTableData && setViewButtonState(positionTableData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positionTableData])

  useEffect(() => {
    formDependencies.currencies && mainFormState?.currency && setFee(mainFormState?.currency)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainFormState?.currency, formDependencies.currencies])

  useEffect(() => {
    if (mainFormState?.counterpart) {
      updateContractsOptions(mainFormState?.counterpart, !(contracts.length === 0))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainFormState?.counterpart])

  useEffect(() => {
    if (
      formDependencies.deliveryPoints.length > 0 &&
      mainFormState?.deliveryPoint &&
      mainFormState?.deliveryPointDescription
    ) {
      const isDeliveryPointMissing = !formDependencies.deliveryPoints.some(
        dp => dp.value === mainFormState?.deliveryPoint
      )

      isDeliveryPointMissing &&
        checkDeliveryPoint(mainFormState?.deliveryPoint, mainFormState?.deliveryPointDescription)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDependencies.deliveryPoints, mainFormState])

  useEffect(() => {
    if (formStateAditionals?.contract && contracts.length > 0) {
      getSelectedContract(formStateAditionals?.contract)
    }

    if (contracts.length > 0 && formStateAditionals?.contract && !pendingChanges) {
      updateBillingForTrade(formStateAditionals)
      setBillingLevelDisabled(false)
      setBillingCycleDisabled(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formStateAditionals?.contract, contracts])

  useEffect(() => {
    // Filter unit measures options for Trade's Currency.
    trade &&
      trade.currency &&
      unitPrices.length > 0 &&
      measureUnits.length > 0 &&
      formDependencies.currencies.length > 0 &&
      setFilterQuantityUnit(trade.currency)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [measureUnits, formDependencies.currencies, unitPrices])

  useEffect(() => {
    setTimeout(() => {
      setMainFormState(prevState => {
        const total = getTotalQuantity({
          initDate: prevState?.initDate,
          endDate: prevState?.endDate,
          dailyQuantity: prevState?.dailyQuantity
        })
        return {
          ...prevState,
          totalQuantity: total
        }
      })
    }, 600)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainFormState?.dailyQuantity])

  //#endregion

  const updateCommissionsList = (brokers: Broker[]) => {
    setContractedProducts(brokers)
    setPendingChanges(true)
  }

  const onEditPositionTable = editPosition => {
    const index = positionTableData.findIndex(pos => pos.codPosicion === editPosition.codPosicion)
    const auxPositionTableData = [...positionTableData]
    auxPositionTableData[index] = editPosition
    setPositionTableData(auxPositionTableData)
  }

  const onDeletePosition = editPosition => {
    const index = positionTableData.findIndex(pos => pos.codPosicion === editPosition.codPosicion)
    const auxPositionTableData = [...positionTableData]
    auxPositionTableData.splice(index, 1)
    setPositionTableData(auxPositionTableData)
  }

  const onAddPositionToTable = newPoss => {
    if ((!mainFormState?.initDate || !mainFormState?.endDate) && positionTableData.length < 1) {
      setMainFormState(prevState => {
        return {
          ...prevState,
          initDate: prevState?.initDate || newPoss.fechaInicio,
          endDate: prevState?.endDate || newPoss.fechaFin
        }
      })
    }
    setPositionTableData([...positionTableData, newPoss])
  }

  const isPriceIncompleteOrInvalid = (): boolean => {
    if (
      expressionValidated &&
      priceUnitSelected &&
      priceCalculationTypeSelected &&
      roundingSelected &&
      priceExpression
    ) {
      return false
    } else if (
      (!priceUnitSelected && !roundingSelected && typeof priceExpression === 'undefined') ||
      priceExpression === ''
    ) {
      return false
    } else {
      return true
    }
  }

  return showAddPositionForm ? (
    <Page fullWidth={false}>
      <PositionForm
        tradeMode={mode}
        positionMode={positionFormMode}
        currency={mainFormState?.currency || 1}
        tradeDatesInterval={
          mainFormState
            ? { startDate: mainFormState.initDate, endDate: mainFormState.endDate }
            : undefined
        }
        counterpart={mainFormState?.counterpart}
        trade={trade}
        position={currentPosition}
        price={price}
        isSimple={currentPosition && currentPosition.tramos && currentPosition.tramos.length > 0}
        deletable={positionTableData && positionTableData.length > 1}
        onRefreshTrade={() => trade && trade.tradeId && fetchTrade()}
        initialDependencies={formDependencies}
        onAddPositionToTable={onAddPositionToTable}
        onEditPositionTable={onEditPositionTable}
        onDeletePosition={handleDeletePosition}
        onGoBack={() => {
          setShowAddPositionForm(false)
          setCurrentPosition(undefined)
        }}
      />
    </Page>
  ) : (
    <Page fullWidth={false}>
      <PageHeader
        title={
          trade && mode === FormMode.EDIT
            ? t('tradesEdit:title', { tradeCode: trade.code })
            : t('trades:forms.add.title')
        }
      >
        <Button onClick={handleDiscard} size="small" color="primary">
          {validations.isDirty || (!complexView && isPriceIncompleteOrInvalid()) || !pendingChanges
            ? t('trades:forms.mainActions.back')
            : t('trades:forms.mainActions.discardChanges')}
        </Button>
        <Button
          onClick={handleChangeView}
          size="small"
          color="primary"
          disabled={viewButtonDisabled}
        >
          {complexView
            ? t('trades:forms.add.mainActions.goToSimpleView')
            : t('trades:forms.add.mainActions.goToComplexView')}
        </Button>
        {mode === FormMode.EDIT && (
          <ButtonWithPermissions
            onClick={onDeleteClickHandler}
            size="small"
            color="primary"
            hasPermission={hasPermission(Resources.Trades, [UserPermission.EDIT])}
          >
            {t('tradesEdit:mainActions.delete')}
          </ButtonWithPermissions>
        )}
        {userHasPermissions && (
          <ButtonWithPermissions
            variant="contained"
            onClick={mode === FormMode.EDIT ? onUpdateHandler : onCreateHandler}
            size="small"
            color="primary"
            hasPermission={hasPermission(Resources.Trades, [UserPermission.EDIT])}
            disabled={
              validations.isDirty ||
              (!complexView && isPriceIncompleteOrInvalid()) ||
              !pendingChanges
            }
          >
            {t('tradesEdit:mainActions.save')}
          </ButtonWithPermissions>
        )}
      </PageHeader>
      {isFetching ? (
        <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9} />
      ) : (
        <>
          <div className={classes.additionalFormStyle}>
            <Form sections={sections} data={mainFormState} options={options} />
          </div>
          {!complexView && (mode === FormMode.EDIT || mode === FormMode.CREATE) ? (
            !isFetching ? (
              <PriceExpressionValidator
                title={t('tradesEdit:forms.sections.price.title')}
                showPriceUnit
                showVersion
                showRounding
                clearablePriceUnit
                clearableRounding
                readOnly={!editMode}
                priceType={EnumPriceType.Formula}
                commodity={EnumCommodity.GasNatural}
                onIsValid={isValid => {
                  setExpressionValidated(isValid)
                }}
                activeExpressionIsValid={priceExpression ? true : undefined}
                activeExpression={priceExpression}
                activePriceCalculationType={
                  priceCalculationTypeSelected ? priceCalculationTypeSelected : undefined
                }
                activeRounding={roundingSelected}
                activePriceUnit={priceUnitSelected}
                priceVersion={priceVersion}
                onSelectValidExpression={expression => {
                  expression &&
                    expression !== priceFields?.priceExpression &&
                    setPendingChanges(true)
                  setPriceFields({ ...priceFields, priceExpression: expression })
                  setPriceExpression(expression)
                }}
                onSelectPriceCalculationType={selected => {
                  setPriceFields({ ...priceFields, priceCalculationType: selected })
                  setPriceCalculationTypeSelected(selected)
                  if (
                    priceFields?.priceCalculationType &&
                    priceFields?.priceCalculationType !== selected &&
                    enumEnumToValueNumber(
                      EnumPriceCalculationType,
                      priceFields?.priceCalculationType
                    ) !== selected
                  ) {
                    setPendingChanges(true)
                  }
                }}
                onSelectPriceUnit={selected => {
                  setPriceFields({ ...priceFields, precioUnitario: selected })
                  setPriceUnitSelected(selected)
                  setPendingChanges(true)
                }}
                onSelectRounding={selected => {
                  setPriceFields({ ...priceFields, redondeo: selected })
                  setRoundingSelected(selected)
                  setPendingChanges(true)
                }}
              />
            ) : (
              <FormSkeleton withTitle={true} elevation={0} columns={3} inputs={6} />
            )
          ) : (
            <Card>
              <CardHeader
                className={classes.additionalCardHeaderStyle}
                title={t('tradesEdit:forms.sections.positions.tableTitle')}
              ></CardHeader>
              <CardContent style={{ paddingTop: 0 }}>
                <TradePositionTable
                  tableData={positionTableData}
                  setShowAddPosition={show => {
                    setShowAddPositionForm(show)
                    setPositionFormMode(FormMode.CREATE)
                  }}
                  onEditPosition={position => handleEditPosition(position)}
                  canEdit={userHasPermissions}
                />
              </CardContent>
            </Card>
          )}
          <Card>
            <CardContent style={{ paddingTop: 0 }}>
              <AccordionSection sectionTitle={t('trades:forms.add.sections.commissions.title')}>
                {!isSimpleCommission ? (
                  <BrokersTable
                    updateCommissionsList={updateCommissionsList}
                    editMode={editMode}
                    commissions={formDependencies.contractedProducts}
                    brokersList={formDependencies.brokers}
                    tableData={brokersList}
                    setTableData={broker => {
                      setBrokersList(broker)
                      setPendingChanges(true)
                    }}
                  />
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <SelectList
                        inputType="outlined"
                        name="broker"
                        label={t('trades:forms.add.sections.commissions.inputs.broker')}
                        options={formDependencies.brokers}
                        value={
                          brokersList && brokersList.length > 0 && brokersList[0].subjectId
                            ? brokersList[0].subjectId
                            : undefined
                        }
                        onChange={onChangeBrokersSelect}
                        disabled={
                          !hasPermission(Resources.Trades, [
                            UserPermission.EDIT,
                            UserPermission.READ_ONLY
                          ])
                        }
                        clearable={true}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <SelectList
                        inputType="outlined"
                        name="commission"
                        label={t('trades:forms.add.sections.commissions.inputs.commission')}
                        options={formDependencies.contractedProducts}
                        value={
                          brokersList && brokersList.length > 0 && brokersList[0].commissionId
                            ? brokersList[0].commissionId
                            : undefined
                        }
                        clearable={true}
                        disabled={commisionDisabled}
                        onChange={onChangeCommissionsSelect}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <AddButton
                        onClick={() => {
                          setIsSimpleCommission(false)
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </AccordionSection>
            </CardContent>
          </Card>
          <div className={classes.additionalFormStyle}>
            <Form
              sections={sectionsAditionals}
              data={formStateAditionals}
              options={optionsAditionals}
            />
          </div>
        </>
      )}
      <ErrorDetailList {...errorDetailListDialogProps} />
    </Page>
  )
}
